import { Box, Divider } from '@mui/material'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { dateMonthToView, dateToView, timeToView } from 'utils/date.utils'


type pdfA5EN = {
    branchInfo: any
    appointment: any
    user: any
    size: string
}

const PDFA5EN = (props: pdfA5EN) => {
    const { size, branchInfo, appointment, user } = props
    const { t } = useTranslation()
    return (

        <Box>
            <Box>
                <Box display={'flex'} justifyContent={'space-between'}>
                    <Box display="flex" width="100%">
                        <Box sx={{ flex: '0 0 20%', display: 'flex', justifyContent: 'center', alignItems: 'center', img: { height: 100, width: 'auto' } }}>
                            {branchInfo?.branchLogo && <img src={branchInfo.branchLogo} alt="logo" />}
                        </Box>
                        <Box
                            sx={{ flex: '0 0 55%', px: 2, textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <Box mb={1}>
                                <Box fontSize={18} fontWeight="bold">
                                    {branchInfo?.clinicNameEn ?? ''}
                                </Box>
                                <Box fontSize={12}>
                                    {branchInfo?.branchNameEn ?? ''}
                                </Box>
                            </Box>
                            <Box>
                                <Box fontSize={12}>
                                    {branchInfo?.branchFullAddressEn ?? ''}
                                </Box>
                                <Box fontSize={12}>
                                    {`${t('APPOINTMENT.PDF.WEB_EN')}: ${branchInfo?.branchWebsite ?? ''} / ${t('APPOINTMENT.PDF.EMAIL_EN')}: ${branchInfo?.branchEmail ?? ''}`}
                                </Box>
                                <Box fontSize={12}>
                                    {`${t('APPOINTMENT.PDF.TEL_EN')}: ${branchInfo?.branchPhone1 ?? ''} ${t('APPOINTMENT.PDF.LINE_EN')}@: ${branchInfo?.branchLine ?? ''}`}
                                </Box>
                            </Box>
                        </Box>
                        <Box sx={{ flex: '0 0 25%', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start' }}>
                            <Box border="1px solid #b8b8b8" p="2px 4px" width="fit-content">
                                <Box whiteSpace="nowrap" fontSize={12}>
                                    <Box component="span" fontWeight="bold">
                                        {t('APPOINTMENT.PDF.APPOINTMENT_NUMBER_EN')}:
                                    </Box>
                                    {appointment?.appointmentNumber ?? ''}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <Box margin={'16px 0 0 0'}>
                    <Box display={'flex'} justifyContent={'space-between'} marginBottom={'8px'}>
                        <Box display={'flex'} gap={'12px'}>
                            <Box whiteSpace={'nowrap'} fontSize={'14px'}>
                                <Box component="span" sx={{ fontWeight: 'bold', fontSize: '14px' }}>{t('APPOINTMENT.PDF.PATIENT_CN_NUMBER_EN')}:{' '}</Box> {appointment?.cnNumber ?? ''}
                            </Box>
                            <Box whiteSpace={'nowrap'} fontSize={'14px'}>
                                <Box component="span" sx={{ fontWeight: 'bold', fontSize: '14px' }}>{t('APPOINTMENT.PDF.PATIENT_NAME_EN')}:{' '}</Box> {`${appointment?.prefixNameEn ?? ''} ${appointment?.firstnameEn === null || appointment?.firstnameEn === '' ? appointment?.firstname : appointment?.firstnameEn} ${appointment?.lastnameEn === null || appointment?.lastnameEn === '' ? appointment?.lastname : appointment?.lastnameEn}`}
                            </Box>
                        </Box>
                        <Box display={'flex'}>
                            <Box whiteSpace={'nowrap'} fontSize={'14px'}>
                                <Box component="span" sx={{ fontWeight: 'bold', fontSize: '14px' }}>{t('APPOINTMENT.PDF.DOCTOR_NAME_EN')}:{' '}</Box>  {appointment?.doctorFirstnameEn ?? ''} {appointment?.doctorLastnameEn ?? ''}
                            </Box>
                        </Box>
                    </Box>
                    <Box display={'flex'} marginBottom={'8px'} gap={'12px'}>
                        <Box whiteSpace={'nowrap'} fontSize={'14px'}>
                            <Box component="span" sx={{ fontWeight: 'bold', fontSize: '14px' }}>{t('APPOINTMENT.PDF.DATE_EN')}:{' '}</Box> {appointment?.date ? dateMonthToView(appointment?.date, true, 'en') : ''}
                        </Box>
                        <Box whiteSpace={'nowrap'} fontSize={'14px'}>
                            <Box component="span" sx={{ fontWeight: 'bold', fontSize: '14px' }}>{t('APPOINTMENT.PDF.TIME_EN')}:{' '}</Box> {`${appointment?.timeStart?.substring(0, 5)} ${t('APPOINTMENT.PDF.TIME_UNIT_EN')}`}
                        </Box>
                    </Box>
                    <Divider sx={{ margin: '0 !important', borderColor: '#b8b8b8 !important', height: '0.5px !important' }} />
                </Box>
            </Box>
            <Box>
                <Box display={'flex'} sx={{ height: '80px', left: 0, right: 0 }}>
                    <Box flexBasis={'17%'}>
                        <Box component="span" sx={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {t('APPOINTMENT.PDF.TREATMENT_EN')}:
                        </Box>
                    </Box>
                    <Box flexBasis={'83%'}>
                        <Box sx={{
                            display: '-webkit-box',
                            WebkitLineClamp: 4,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            fontSize: '14px',
                        }}>
                            {appointment?.appointmentOperatives?.map((item: any, index: any) => (
                                item?.operativeNameEn || item?.operativeTypeNameEn
                            )).join(',')}
                        </Box>
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: '8px', height: '80px' }}>
                    <Box whiteSpace="nowrap" sx={{ fontWeight: 'bold', fontSize: '14px', flex: '0 0 auto' }} >
                        {t('APPOINTMENT.PDF.PRACTICE_EN')}:
                    </Box>
                    <Box sx={{ flex: 1, display: '-webkit-box', WebkitLineClamp: 4, WebkitBoxOrient: 'vertical', overflow: 'hidden', fontSize: '14px', lineHeight: '1.4', wordBreak: 'break-word' }}>
                        {appointment?.practice ?? ''}
                    </Box>
                </Box>
                <Box sx={{ position: 'fixed', flexDirection: 'row', alignItems: 'flex-start', gap: '8px', height: '80px' }}>
                    <Box whiteSpace="nowrap" sx={{ fontWeight: 'bold', fontSize: '14px', flex: '0 0 auto' }} >
                        {t('APPOINTMENT.PDF.REMARK_EN')}:
                    </Box>
                    <Box sx={{ flex: 1, display: '-webkit-box', WebkitLineClamp: 4, WebkitBoxOrient: 'vertical', overflow: 'hidden', fontSize: '14px', lineHeight: '1.4', wordBreak: 'break-word' }}>
                        {appointment?.remark ?? ''}
                    </Box>
                </Box>
                {size !== 'sm' ?
                    <Box sx={{ position: 'fixed', right: 0, bottom: 25 }}>
                        <Box whiteSpace={'nowrap'} fontSize={'14px'}>
                            <Box component="span" sx={{ fontWeight: 'bold' }}>{t('APPOINTMENT.PDF.AUTH_EN')}:{' '}</Box>
                            {user?.fullnameEn ?? ''}
                        </Box>
                        <Box sx={{ position: 'fixed', right: 0, bottom: 0 }}>
                            <Box fontSize={'14px'}>{`${dateToView(moment())}  ${timeToView()} ${t('APPOINTMENT.PDF.TIME_UNIT_EN')}`}</Box>
                        </Box>
                    </Box> : <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', boxSizing: 'border-box' }}>
                        <Box sx={{ mt: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '4px' }}>
                            <Box whiteSpace="nowrap" fontSize={14}>
                                <Box component="span" fontWeight="bold">
                                    {t('APPOINTMENT.PDF.AUTH_EN')}:&nbsp;
                                </Box>
                                {user?.fullnameEn}
                            </Box>
                            <Box fontSize={14}>
                                {`${dateToView(moment())}  ${timeToView()} ${t('APPOINTMENT.PDF.TIME_UNIT_EN')}`}
                            </Box>
                        </Box>
                    </Box>}
            </Box>
        </Box>
    )
}

export default PDFA5EN